
import React from 'react'
import PropTypes from 'prop-types'
import UnexpectedError from '../../../screens/error/UnexpectedError'
import { getLayoutElementDetails } from 'utils/screens/common'

class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  }

  state = {}

  static getDerivedStateFromError(err) {
    if (err.justLogDontThrow) {
      return {}
    }
    return { hasError: true, error: err }
  }

  render() {
    if ((this.state as any).hasError) {
      const { LayoutElement, layoutElementProps } = getLayoutElementDetails()
      return (
        <LayoutElement {...layoutElementProps}>
          <UnexpectedError error={(this.state as any).error} />
        </LayoutElement>
      )
    }
    return (this.props as any).children
  }
}

export default ErrorBoundary

export function noopWarn() {
  const error = new Error('undefined function called with args ' + JSON.stringify(arguments))
  ;(error as any).justLogDontThrow = true
  throw error
}
